import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';

import { formatFilters } from 'helpers/formatters';
import { convertToReal, convertFormattedMoneyAndNegativeMoneyToNumber } from 'helpers/converters';

import { Row, getCategoryMethodNameById, getAccountNameById, getPaymentMethodNameById, REFACTOR_DATE } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

import { loadFilters } from 'components/Filter/store/thunk';

export default function TransactionUpdate({ activityData, lastRegister, newRegister, transaction }) {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);

  const { selects } = useSelector(state => state.filters);

  const accounts = formatFilters(['account'], selects)[0]?.options;
  const paymentMethods = formatFilters(['paymentMethod'], selects)[0]?.options;
  const receiptCategories = formatFilters(['receiptCategory'], selects)[0]?.options;
  const paymentCategories = formatFilters(['paymentCategory'], selects)[0]?.options;

  const categories = [
    ...receiptCategories,
    ...paymentCategories
  ]

  const isReceipt = +transaction?.transactionTypeId == 1;

  useEffect(() => {
    dispatch(loadFilters(userId, establishmentId));
  }, []);

  if(moment(activityData?.updatedAt, 'YYYY-MM-DD HH:mm:ss').isBefore(REFACTOR_DATE)) {
    return(
      <Grid container>
        <Grid xs={12}>
          <ActivitiesRegistrationHeader activityData={activityData} />
          <Grid container style={{ marginTop: 10 }}>
            <Grid xs={12} style={{ padding: 5 }}>
              <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
                <b>Transação Anterior</b>
              </Typography>
              <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
                <Row>
                  <Typography color='primary'>
                    <b>Descrição</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.transaction?.description}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Categoria</b>
                  </Typography>
                  <Typography color='textSecondary'>{getCategoryMethodNameById(categories, lastRegister?.transaction?.categoryId)}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Dia do vencimento</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(lastRegister?.transaction?.previsionDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>{isReceipt ? 'Conta destino' : 'Conta origem'}</b>
                  </Typography>
                  <Typography color='textSecondary'>{getAccountNameById(accounts, lastRegister?.transaction?.accountId)}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(convertFormattedMoneyAndNegativeMoneyToNumber(lastRegister?.transaction?.amount))}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Data da receita</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(lastRegister?.transaction?.paymentDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
                {isReceipt && (
                  <Row>
                    <Typography color='primary'>
                      <b>Método de pagamento</b>
                    </Typography>
                    <Typography color='textSecondary'>{getPaymentMethodNameById(paymentMethods, lastRegister?.transaction?.paymentMethodId)}</Typography>
                  </Row>
                )}
              </Grid>
            </Grid>
            <Grid xs={12} style={{ padding: 5, marginBottom: 5 }}>
              <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
                <b>Transação Atual</b>
              </Typography>
              <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
                <Row>
                  <Typography color='primary'>
                    <b>Descrição</b>
                  </Typography>
                  <Typography color='textSecondary'>{transaction?.description}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Categoria</b>
                  </Typography>
                  <Typography color='textSecondary'>{getCategoryMethodNameById(categories, transaction?.categoryId)}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Dia do vencimento</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(transaction?.previsionDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>{isReceipt ? 'Conta destino' : 'Conta origem'}</b>
                  </Typography>
                  <Typography color='textSecondary'>{getAccountNameById(accounts, transaction?.accountId)}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(convertFormattedMoneyAndNegativeMoneyToNumber(transaction?.amount))}</Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Data da receita</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(transaction?.paymentDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
                {isReceipt && (
                  <Row>
                    <Typography color='primary'>
                      <b>Método de pagamento</b>
                    </Typography>
                    <Typography color='textSecondary'>{getPaymentMethodNameById(paymentMethods, transaction?.paymentMethodId)}</Typography>
                  </Row>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader activityData={activityData} />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Transação Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(lastRegister).includes('description') && (
                <Row>
                  <Typography color='primary'>
                    <b>Descrição</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.description}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('categoryId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Categoria</b>
                  </Typography>
                  <Typography color='textSecondary'>{getCategoryMethodNameById(categories, lastRegister?.categoryId)}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('previsionDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Dia do vencimento</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(lastRegister?.previsionDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('accountId') && (
                <Row>
                  <Typography color='primary'>
                    <b>{isReceipt ? 'Conta destino' : 'Conta origem'}</b>
                  </Typography>
                  <Typography color='textSecondary'>{getAccountNameById(accounts, lastRegister?.accountId)}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('amount') && (
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(convertFormattedMoneyAndNegativeMoneyToNumber(lastRegister?.amount))}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('paymentDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data da receita</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(lastRegister?.paymentDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('paymentMethodId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Método de pagamento</b>
                  </Typography>
                  <Typography color='textSecondary'>{getPaymentMethodNameById(paymentMethods, lastRegister?.paymentMethodId)}</Typography>
                </Row>
              )}
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5, marginBottom: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Transação Atual</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(newRegister).includes('description') && (
                <Row>
                  <Typography color='primary'>
                    <b>Descrição</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.description}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('categoryId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Categoria</b>
                  </Typography>
                  <Typography color='textSecondary'>{getCategoryMethodNameById(categories, newRegister?.categoryId)}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('previsionDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Dia do vencimento</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(newRegister?.previsionDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('accountId') && (
                <Row>
                  <Typography color='primary'>
                    <b>{isReceipt ? 'Conta destino' : 'Conta origem'}</b>
                  </Typography>
                  <Typography color='textSecondary'>{getAccountNameById(accounts, newRegister?.accountId)}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('amount') && (
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(convertFormattedMoneyAndNegativeMoneyToNumber(newRegister?.amount))}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('paymentDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data da receita</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(newRegister?.paymentDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('paymentMethodId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Método de pagamento</b>
                  </Typography>
                  <Typography color='textSecondary'>{getPaymentMethodNameById(paymentMethods, newRegister?.paymentMethodId)}</Typography>
                </Row>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

TransactionUpdate.propTypes = {
  transaction: PropTypes.object.isRequired,
  lastRegister: PropTypes.object.isRequired,
  activityData: PropTypes.object.isRequired
};